import { FC } from 'react';
import { Box } from 'roo-ui/components';

import BookingAlert from 'components/BookingAlert';
import { DetailsBooking } from 'types';

interface CancelledStateMessageProps {
  booking: DetailsBooking;
}

const CancelledStateMessage: FC<CancelledStateMessageProps> = ({ booking }) => {
  if (!booking.flags.isCancelled) {
    return null;
  }

  const { email } = booking.travelArranger;

  return (
    <BookingAlert icon="cancel" data-testid="booking-cancelled-message" data-hj-suppress>
      <Box display={['block', 'inline']}>
        <strong>Your booking has been cancelled.</strong>
      </Box>{' '}
      A confirmation email has been sent to <strong>{email}</strong>
    </BookingAlert>
  );
};

export default CancelledStateMessage;
